import Head from "next/head";
import { getBrands } from "@components/config/helpers";
import dynamic from "next/dynamic";
import PageHead from "@components/Components/Reusables/PageHead";

const FirstTimeHiringGuide = dynamic(() => import("Features/ECOMM/FirstTimeHiringGuide/components/FirstTimeHiringGuide"));


const FirstTimeHire = () => {

    return (
        <>
            <PageHead
                title="First Time Hire Guide - Vital Info - Quick &amp; Easy"
                description="We offer affordable chair and table hire across London, seven days a week. Same day and next day deliveries with no minimum charge. Free no obligation quotation."
                ogTitle="First Time Hire Guide - Vital Info - Quick &amp; Easy"
                ogDescription="We offer affordable chair and table hire across London, seven days a week. Same day and next day deliveries with no minimum charge. Free no obligation quotation."
                ogType="website"
                ogUrl="https://www.furniturehireuk.com/first-time-hire"
                ogImage="https://www.furniturehireuk.com/_next/image?url=%2Fimages%2FFHUK%2Flogo-main.png&w=384&q=75"
            />
            <FirstTimeHiringGuide />

        </>
    );
};

export async function getServerSideProps({ query, res }) {

    res.setHeader(
        'Cache-Control',
        'public, s-maxage=43200, stale-while-revalidate=59'
    );

    if (!getBrands(['CH'])) {
        return { notFound: true }
    }

    return {
        props: {
            data: {
                breadcrumb: {
                    'last': 'First Time Hiring Guide',
                    'links': []
                },
                template_page_settings: {
                    sidenav: 'yes'
                }
            }
        }
    };

}

export default FirstTimeHire;
